import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/vendors/settings/surveys/index/Page";
import { Page as Error403Component } from "~/containers/specifics/vendors/403/Page";
import { useSessions } from "~/hooks/vendors/useSessions";

export const PATH = "/vendors/settings/surveys";

const SurveysSetting: NextPage = () => {
	const { data: session } = useSessions().index();
	if (!session?.admin) {
		return <Error403Component />;
	}

	return (
		<>
			<NskHead title="アンケート設定" />
			<Component />
		</>
	);
};

export default SurveysSetting;
